// src/utils/country-name.jsx
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

/** common vendor aliases */
const SPECIAL = { UK: "GB", UAE: "AE" };

/** vendor/CLDR pseudo region codes -> parent ISO + display label */
const PSEUDO = {
  IC: { a2: "ES", label: "Canary Islands" },
  EA: { a2: "ES", label: "Ceuta & Melilla" },
  AN: { a2: "AN", label: "Netherlands Antilles" }, // change NL to provider’s mapping if needed
};

/** neutral, product-friendly display overrides */
const OVERRIDES = {
  TW: "Taiwan",
  // optional (if you prefer short form everywhere):
   US: "United States",
  // CN: "China",
  // HK: "Hong Kong",
  // MO: "Macau",
};

/** name aliases for vendor/official strings that might come from APIs */
const NAME_ALIASES = [
  [/^taiwan,\s*province of china$/i, "TW"],
  // optional extras if you see them:
  // [/^united states of america$/i, "US"],
  // [/^people'?s republic of china$/i, "CN"],
];

export function normalizeCountry(val) {
  if (!val) return "";
  const raw = String(val).trim();
  const up = raw.toUpperCase();

  // keep pseudo codes so we can display them nicely
  if (PSEUDO[up]) return up;

  if (/^[A-Z]{2}$/.test(up)) return SPECIAL[up] || up;

  if (/^[A-Z]{3}$/.test(up)) return countries.alpha3ToAlpha2(up) || "";

  // map known “official” strings to ISO
  for (const [re, code] of NAME_ALIASES) {
    if (re.test(raw)) return code;
  }

  const a2FromName = countries.getAlpha2Code(raw, "en");
  return a2FromName ? a2FromName.toUpperCase() : "";
}

/** ISO A2 for URLs/filters */
export function toA2(v) {
  const code = normalizeCountry(v);
  if (PSEUDO[code]) return PSEUDO[code].a2;
  return code;
}

/** User-facing label (deterministic SSR + client) */
export function countryName(val) {
  const code = normalizeCountry(val);
  if (!code) return val || "";

  if (PSEUDO[code]) return PSEUDO[code].label;
  if (OVERRIDES[code]) return OVERRIDES[code];

  return countries.getName(code, "en") || code; // common name
}
